<template>
  <section class="container">
    <div class="row">
      <div class="col-xs-12 col-sm-10 col-sm-offset-1 text-center">
        <h2>
          <contentful-text
            :item="contentfulText('homepage-2023-v01-callout-1-title')"
            :render-inline="true"
          />
        </h2>
      </div>
      <div class="col-xs-12 col-sm-8 col-sm-offset-2 text-center">
        <contentful-text
          :item="contentfulText('homepage-2023-v01-callout-1-body')"
          :apply-markdown="true"
          class="content-section__text"
        />
      </div>
    </div>
    <div class="text-center">
      <a
        :href="contentfulText('homepage-2023-v01-callout-1-cta-url').Content"
        class="btn content-section__btn content-section__btn--white-bg-red-border"
      >
        <contentful-text
          :item="contentfulText('homepage-2023-v01-callout-1-cta-label')"
          :render-inline="true"
        />
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContentSectionAlpha',
  computed: {
    content () {
      return this.$store.state.pageContent
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  font-family: $font-barlow-condensed;
  font-size: 1.625rem;
  font-weight: 600;
  line-height: 1.875rem;
  text-transform: uppercase;

  @media screen and (min-width: $screen-sm-min) {
    font-size: 3.375rem;
    line-height: 3.875rem;
  }

  @media screen and (min-width: $screen-lg-min) {
    padding: 0 2rem;
  }
}

.content-section {
  &__text {
    & /deep/ p {
      font-size: 1.1rem;
      font-family: $font-circular-std;
      line-height: 1.8rem;
      padding: 0 2.4rem;
      margin-bottom: 1rem;
    }
  }

  &__btn {
    border-radius: 34px;
    font-family: $font-circular-std;
    font-weight: bold;
    text-transform: uppercase;
    padding: 0.8rem 1.4rem;
    font-size: 1rem;

    &--white-bg-red-border {
      background-color: #fff;
      border: 1px solid #d02a2f;
      color: #000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/home/index/components/ContentSections/Alpha.vue